import { PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js';

import { Skeleton } from '@zooplus/ui-components';

import { usePayPalButtonContext } from '@providers/PayPalButtonContextProvider';

import type { PayPalButtonsComponentProps } from '@paypal/react-paypal-js/dist/types/types';

export type PayPalButtonProps = Pick<
  PayPalButtonsComponentProps,
  'createOrder' | 'createVaultSetupToken' | 'style' | 'onClick' | 'onError'
>;

const PayPalButton = ({
  createOrder,
  createVaultSetupToken,
  style,
  onClick,
  onError,
}: PayPalButtonProps) => {
  const [{ isResolved }] = usePayPalScriptReducer();
  const { onApprove, onCancel, isButtonDisabled } = usePayPalButtonContext();
  const fundingSource = 'paypal';

  // Render a loading skeleton if the PayPal Javascript SDK is not yet loaded and resolved
  if (!isResolved) {
    return <Skeleton />;
  }

  return (
    <PayPalButtons
      fundingSource={fundingSource}
      onClick={onClick}
      createOrder={createOrder}
      onApprove={onApprove}
      onError={onError}
      onCancel={onCancel}
      style={style}
      createVaultSetupToken={createVaultSetupToken}
      disabled={isButtonDisabled}
    />
  );
};

export default PayPalButton;
